module.exports = __webpack_public_path__ + "static/media/Item_Weapon_vz61Skorpion_C.19db0fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Handgun/Item_Weapon_vz61Skorpion_C.png
// module id = 208
// module chunks = 0